import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export default function CtaSection({ title, desc, buttonText, image, buttonLink }) {
  const { lang, t, localizePath } = useLanguage();

  const defaultTitle = title || (t ? t('about.cta_title') : (lang === 'da' ? 'Klar til at tage det første skridt?' : 'Ready to take the first step?'));
  const defaultDesc = desc || (t ? t('about.cta_desc') : (lang === 'da' ? 'Book en indledende samtale, og lad os finde ud af, hvordan vi bedst kan hjælpe dig.' : 'Book an initial consultation and let us find out how we can best help you.'));
  const defaultBtn = buttonText || (t ? t('about.cta_btn') : (lang === 'da' ? 'Book en indledende samtale' : 'Book an initial consultation'));
  const bgImg = image || 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=85,format=auto/assets/7d97f2cb-1a26-4176-9980-5fb38f404ca8/shutterstock-2705737533.jpg';

  const href = buttonLink || '/kontakt';
  const isExternal = typeof href === 'string' && (href.startsWith('http://') || href.startsWith('https://') || href.startsWith('mailto:') || href.startsWith('tel:'));

  return (
    <section className="grid grid-cols-1 lg:grid-cols-[48%_52%] min-h-[260px]">
      <div className="bg-[#1e3a35] flex flex-col justify-center px-6 py-12 md:py-16 lg:pl-[calc((100vw-1180px)/2)] lg:pr-12 xl:pl-[calc((100vw-1180px)/2)]">
        <div className="max-w-[455px] mx-auto lg:mx-0">
          <h3 className="font-display text-3xl font-normal text-white mb-2">
            {defaultTitle}
          </h3>
          <p className="text-sm text-white/80 mb-6">
            {defaultDesc}
          </p>
          {isExternal ? (
            <a 
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-white text-petrol-dark text-sm font-semibold px-6 py-3 rounded-full hover:bg-sand-light transition-colors group cursor-pointer"
            >
              {defaultBtn}
              <span className="text-lg transition-transform group-hover:translate-x-1">→</span>
            </a>
          ) : (
            <Link 
              to={localizePath(href)} 
              className="inline-flex items-center gap-3 bg-white text-petrol-dark text-sm font-semibold px-6 py-3 rounded-full hover:bg-sand-light transition-colors group cursor-pointer"
            >
              {defaultBtn}
              <span className="text-lg transition-transform group-hover:translate-x-1">→</span>
            </Link>
          )}
        </div>
      </div>
      <div 
        className="min-h-[260px] lg:min-h-full bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url('${bgImg}')` }}
      />
    </section>
  );
}
